import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { redirectUnauthorized } from '../utils/errors';
import { mapError } from '../utils/alerts/error';
import { handleError } from '../service/base.service';

function useErrorProneRequest() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const executeRequest = useCallback(
    async (request, onCatch, onFinally) => {
      try {
        setLoading(true);
        await request();
        setError(null);
      } catch (e) {
        onCatch?.(e);
        handleError(e, {
          UnauthorizedError: () => redirectUnauthorized(navigate),
          default: () => setError(mapError(e.name, e.message))
        });
      } finally {
        onFinally?.();
        setLoading(false);
      }
    },
    [navigate]
  );

  return [error, loading, executeRequest];
}

export default useErrorProneRequest;